(function() {
  'use strict';
  const DELAY_ACTIVE = 2500; // ms
  const DELAY_COMPLETE = 3000; // ms

  document.querySelectorAll('[data-trigger]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const targetId = trigger.getAttribute('data-target');
      const target = document.getElementById(targetId);
      if (!target) return;

      target.classList.add('is-active');

      setTimeout(() => {
        target.classList.add('is-complete');
      }, DELAY_ACTIVE);

      setTimeout(() => {
        target.classList.add('is-finished');
      }, DELAY_ACTIVE + DELAY_COMPLETE);
    });
  });
})();
// ============================================= ============================================= ============================================= HERO FLICKITY
(function() {
  'use strict';
  
  // ===== SLIDER-SPECIFIC SELECTORS =====
  const SLIDER_CONTAINER = '.co-nook-1-slider';
  const LAYER_1_SELECTOR = '.co-nook-1-image-1';
  const LAYER_2_SELECTOR = '.co-nook-1-image-2';
  const LAYER_3_SELECTOR = '.co-nook-1-image-3';
  const LAYER_4_SELECTOR = '.co-nook-1-image-4';
  
  // New text button group selectors
  const TEXT_BUTTON_1_SELECTOR = '.co-nook-1-text-button-1';
  const TEXT_BUTTON_2_SELECTOR = '.co-nook-1-text-button-2';
  const TEXT_BUTTON_3_SELECTOR = '.co-nook-1-text-button-3';
  const TEXT_BUTTON_4_SELECTOR = '.co-nook-1-text-button-4';
  
  // Crumbles group selectors
  const CRUMBLES_1_SELECTOR = '.co-nook-1-crumbles-1';
  const CRUMBLES_2_SELECTOR = '.co-nook-1-crumbles-2';
  const CRUMBLES_3_SELECTOR = '.co-nook-1-crumbles-3';
  const CRUMBLES_4_SELECTOR = '.co-nook-1-crumbles-4';

  // Child slider selectors
  const CHILD_SLIDER_CLASS = '.co-nook-1-child-slider';
  const CHILD_CELL_CLASS = '.co-nook-1-child-cell';
  const ACTIVE_CLASS = 'active';
  const PREV_CLASS = 'prev';
  const NEXT_CLASS = 'next';

  // ===== CHECK FOR SLIDER AND MULTIPLE SLIDES =====
  const sliderContainer = document.querySelector(SLIDER_CONTAINER);
  if (!sliderContainer) return;
  
  // Get the slides (Flickity cells) - adjust selector if your cell class differs
  const slides = sliderContainer.children;
  if (slides.length <= 1) {
    // Only one slide or none - don't initialize Flickity
    // Optionally add a class to indicate single-slide state
    sliderContainer.classList.add('single-slide');
    return;
  }

  // ===== TRANSFORM VALUES =====
  const LAYER_1_SCALE = -0.5;
  const LAYER_2_MIRROR_MULTIPLIER = -0.5;
  const LAYER_3_SCALE = 0.2;
  const LAYER_4_PERCENTAGE_MULTIPLIER = 0.2;
  
  // Text button group transform multiplier (adjust this value as needed)
  const TEXT_BUTTON_MULTIPLIER = 0.15; // 0.5 = half, 0.25 = quarter, 1 = same, 2 = double, etc.
  
  // Crumbles group transform multiplier (adjust this value as needed)
  const CRUMBLES_MULTIPLIER = 0.5; // 0.5 = half, 0.25 = quarter, 1 = same, 2 = double, etc.
  
  // Scale configuration - adjust these values as needed
  const SCALE_ACTIVE = 1;    // Scale for centered/active slide
  const SCALE_INACTIVE = 0.95; // Scale for non-centered slides

  // ===== FLICKITY INITIALIZATION =====
  const flkty = new Flickity(SLIDER_CONTAINER, {
    // autoPlay: 2500,
    pageDots: false, 
    selectedAttraction: 0.01,
    friction: 0.2,
    wrapAround: true,
    draggable: true,
    prevNextButtons: true,
    arrowShape: ''
  });

  // ===== HELPER FUNCTIONS (SCOPED TO THIS SLIDER) =====

  function getTranslateX(slider) {
    const style = window.getComputedStyle(slider);
    const matrix = new WebKitCSSMatrix(style.transform);
    return matrix.m41;
  }

  function mirrorTranslateX(translateX, selector, scale = 1) {
    // Only select elements within this slider's context
    const elements = sliderContainer.querySelectorAll(selector);
    const scaledTranslateX = translateX * scale;
    elements.forEach(function(element) {
      element.style.transform = `translateX(${scaledTranslateX}px)`;
    });
  }

  function handleCellTransforms(flickityInstance) {
    flickityInstance.cells.forEach(function(cell) {
      const originalTransform = cell.element.style.transform;
      const translateXMatch = originalTransform.match(/translateX\((-?\d+(\.\d+)?)%\)/);
      
      if (translateXMatch) {
        const translateXValue = parseFloat(translateXMatch[1]);
        
        // Layer 2: Mirror the original translateX value
        const mirroredTranslateXValue = translateXValue * LAYER_2_MIRROR_MULTIPLIER;
        const childElement1 = cell.element.querySelector(LAYER_2_SELECTOR);
        if (childElement1) {
          childElement1.style.transform = `translateX(${mirroredTranslateXValue}%)`;
        }
        
        // Layer 4: Apply percentage multiplier
        const percentageTranslateXValue = translateXValue * LAYER_4_PERCENTAGE_MULTIPLIER;
        const childElement2 = cell.element.querySelector(LAYER_4_SELECTOR);
        if (childElement2) {
          childElement2.style.transform = `translateX(${percentageTranslateXValue}%)`;
        }
        
        // Text Button 2: Apply text button multiplier to mirrored value
        const textButton2TranslateXValue = mirroredTranslateXValue * TEXT_BUTTON_MULTIPLIER;
        const textButton2Element = cell.element.querySelector(TEXT_BUTTON_2_SELECTOR);
        if (textButton2Element) {
          textButton2Element.style.transform = `translateX(${textButton2TranslateXValue}%)`;
        }
        
        // Text Button 4: Apply text button multiplier to percentage value
        const textButton4TranslateXValue = percentageTranslateXValue * TEXT_BUTTON_MULTIPLIER;
        const textButton4Element = cell.element.querySelector(TEXT_BUTTON_4_SELECTOR);
        if (textButton4Element) {
          textButton4Element.style.transform = `translateX(${textButton4TranslateXValue}%)`;
        }
        
        // Crumbles 2: Apply crumbles multiplier to mirrored value
        const crumbles2TranslateXValue = mirroredTranslateXValue * CRUMBLES_MULTIPLIER;
        const crumbles2Element = cell.element.querySelector(CRUMBLES_2_SELECTOR);
        if (crumbles2Element) {
          crumbles2Element.style.transform = `translateX(${crumbles2TranslateXValue}%)`;
        }
        
        // Crumbles 4: Apply crumbles multiplier to percentage value
        const crumbles4TranslateXValue = percentageTranslateXValue * CRUMBLES_MULTIPLIER;
        const crumbles4Element = cell.element.querySelector(CRUMBLES_4_SELECTOR);
        if (crumbles4Element) {
          crumbles4Element.style.transform = `translateX(${crumbles4TranslateXValue}%)`;
        }
      }
    });
  }

  // Track last updated indices to prevent unnecessary updates
  let lastActiveIndex = -1;
  let lastPrevIndex = -1;
  let lastNextIndex = -1;

  function getClosestSlideIndex() {
    const viewport = flkty.viewport;
    const viewportCenter = viewport.offsetWidth / 2;
    let closestIndex = 0;
    let closestDistance = Infinity;
    
    flkty.cells.forEach((cell, index) => {
      const slide = cell.element;
      const slideRect = slide.getBoundingClientRect();
      const viewportRect = viewport.getBoundingClientRect();
      const slideCenterX = slideRect.left + slideRect.width / 2 - viewportRect.left;
      
      const distanceFromCenter = Math.abs(slideCenterX - viewportCenter);
      
      if (distanceFromCenter < closestDistance) {
        closestDistance = distanceFromCenter;
        closestIndex = index;
      }
    });
    
    return closestIndex;
  }

  function updateIsSelectedClass(selectedIndex) {
    flkty.cells.forEach((cell, index) => {
      const slide = cell.element;
      if (index === selectedIndex) {
        slide.classList.add('is-selected');
      } else {
        slide.classList.remove('is-selected');
      }
    });
  }

  // Function to update active state on child slider with prev/next classes
  function updateChildSliderActive(selectedIndex) {
    const childSlider = document.querySelector(CHILD_SLIDER_CLASS);
    if (!childSlider) return;
    
    const childCells = childSlider.querySelectorAll(CHILD_CELL_CLASS);
    const totalCells = childCells.length;
    
    // Calculate prev and next indices (with wrap-around support)
    const prevIndex = selectedIndex === 0 ? totalCells - 1 : selectedIndex - 1;
    const nextIndex = selectedIndex === totalCells - 1 ? 0 : selectedIndex + 1;
    
    // Only update if there's an actual change
    if (selectedIndex === lastActiveIndex && prevIndex === lastPrevIndex && nextIndex === lastNextIndex) {
      return; // No change needed
    }
    
    // Remove all classes from all child cells
    childCells.forEach(cell => {
      cell.classList.remove(ACTIVE_CLASS, PREV_CLASS, NEXT_CLASS);
    });
    
    // Add active class to the corresponding child cell
    if (childCells[selectedIndex]) {
      childCells[selectedIndex].classList.add(ACTIVE_CLASS);
    }
    
    // Add prev class
    if (childCells[prevIndex]) {
      childCells[prevIndex].classList.add(PREV_CLASS);
    }
    
    // Add next class
    if (childCells[nextIndex]) {
      childCells[nextIndex].classList.add(NEXT_CLASS);
    }
    
    // Update tracking variables
    lastActiveIndex = selectedIndex;
    lastPrevIndex = prevIndex;
    lastNextIndex = nextIndex;
  }

  function updateCellClasses(selectedIndex) {
    const totalCells = flkty.cells.length;
    
    // Calculate prev and next indices (with wrapping)
    const prevIndex = (selectedIndex - 1 + totalCells) % totalCells;
    const nextIndex = (selectedIndex + 1) % totalCells;
    
    // Remove existing classes from all cells
    flkty.cells.forEach(function(cell) {
      cell.element.classList.remove('is-prev', 'is-next');
    });
    
    // Add classes to prev and next cells
    if (flkty.cells[prevIndex]) {
      flkty.cells[prevIndex].element.classList.add('is-prev');
    }
    if (flkty.cells[nextIndex]) {
      flkty.cells[nextIndex].element.classList.add('is-next');
    }
  }

  function updateSlideEffects() {
    const viewport = flkty.viewport;
    const viewportCenter = viewport.offsetWidth / 2;
    
    flkty.cells.forEach((cell, index) => {
      const slide = cell.element;
      const scaleTarget = slide.querySelector('.co-nook-1-cell-frame');
      
      if (scaleTarget) {
        scaleTarget.style.transformOrigin = 'center center';
        
        const slideRect = slide.getBoundingClientRect();
        const viewportRect = viewport.getBoundingClientRect();
        const slideCenterX = slideRect.left + slideRect.width / 2 - viewportRect.left;
        const slideWidth = slideRect.width;
        
        // Calculate distance from center in slide widths
        const distanceFromCenter = Math.abs(slideCenterX - viewportCenter) / slideWidth;
        
        let scale;
        
        if (distanceFromCenter <= 1) {
          // Within 1 slide width from center: smooth scaling from active to inactive
          // At distance 0: scale = 1 (SCALE_ACTIVE)
          // At distance 1: scale = 0.9 (SCALE_INACTIVE)
          const scaleDifference = SCALE_ACTIVE - SCALE_INACTIVE;
          scale = SCALE_ACTIVE - (distanceFromCenter * scaleDifference);
          scale = Math.max(scale, SCALE_INACTIVE);
        } else {
          // Beyond 1 slide width: always inactive scale
          scale = SCALE_INACTIVE;
        }
        
        scaleTarget.style.transform = `scale(${scale})`;
      }
    });
  }

  function updateTransforms() {
    // Use scoped slider selector instead of generic '.flickity-slider'
    const slider = document.querySelector(`${SLIDER_CONTAINER} .flickity-slider`);
    if (!slider) return;
    
    const translateX = getTranslateX(slider);
    
    // Original image layers
    mirrorTranslateX(translateX, LAYER_1_SELECTOR, LAYER_1_SCALE);
    mirrorTranslateX(translateX, LAYER_3_SELECTOR, LAYER_3_SCALE);
    
    // Text button layers (corresponding to Layer 1 and Layer 3)
    mirrorTranslateX(translateX, TEXT_BUTTON_1_SELECTOR, LAYER_1_SCALE * TEXT_BUTTON_MULTIPLIER);
    mirrorTranslateX(translateX, TEXT_BUTTON_3_SELECTOR, LAYER_3_SCALE * TEXT_BUTTON_MULTIPLIER);
    
    // Crumbles layers (corresponding to Layer 1 and Layer 3)
    mirrorTranslateX(translateX, CRUMBLES_1_SELECTOR, LAYER_1_SCALE * CRUMBLES_MULTIPLIER);
    mirrorTranslateX(translateX, CRUMBLES_3_SELECTOR, LAYER_3_SCALE * CRUMBLES_MULTIPLIER);
    
    handleCellTransforms(flkty);
    
    // Update slide scaling effects
    updateSlideEffects();
    
    // Update cell classes dynamically
    const closestSlideIndex = getClosestSlideIndex();
    updateCellClasses(closestSlideIndex);
    updateIsSelectedClass(closestSlideIndex);
    updateChildSliderActive(closestSlideIndex);
  }

  // ===== EVENT LISTENERS =====
  flkty.on('ready', function() {
    // Initial transform update after flkty is fully initialized
    updateTransforms();
    updateChildSliderActive(flkty.selectedIndex);
  });
  flkty.on('dragMove', function() {
    updateTransforms();
  });
  flkty.on('scroll', updateTransforms);
  flkty.on('settle', function() {
    updateTransforms();
    // Also update classes when settling completes
    updateCellClasses(flkty.selectedIndex);
    updateIsSelectedClass(flkty.selectedIndex);
    updateChildSliderActive(flkty.selectedIndex);
  });
  flkty.on('select', function() {
    updateCellClasses(flkty.selectedIndex);
    updateIsSelectedClass(flkty.selectedIndex);
    updateChildSliderActive(flkty.selectedIndex);
  });

  // Add click functionality to child cells to control main slider
  const childSlider = document.querySelector(CHILD_SLIDER_CLASS);
  if (childSlider) {
    const childCells = childSlider.querySelectorAll(CHILD_CELL_CLASS);
    
    childCells.forEach((cell, index) => {
      cell.addEventListener('click', function() {
        flkty.select(index);
      });
    });
  }

  // Optional: Expose the instance for external access if needed
  // window.coHome1Slider = flkty;

})();

// ============================================= ============================================= ============================================= SECTION 2 TABS
class Tabs {
  constructor(triggersContainer, options = {}) {
    this.options = { 
      autoActivate: true, 
      loop: true, 
      onChange: null,
      animationDelay: 50, // delay in ms before adding animation attribute
      ...options 
    };
    
    const id = triggersContainer.dataset.tabs;
    const panelsContainer = document.querySelector(`[data-tabs-panels="${id}"]`);
    
    if (!panelsContainer) {
      console.warn(`Tabs: No panels container found for "${id}"`);
      return;
    }
    
    this.tabs = [...triggersContainer.querySelectorAll('[role="tab"]')];
    this.panels = this.tabs.map(tab => {
      const controlsId = tab.getAttribute('aria-controls');
      return panelsContainer.querySelector(`#${controlsId}`) || document.getElementById(controlsId);
    });
    
    this.activeIndex = Math.max(0, this.tabs.findIndex(t => t.getAttribute('aria-selected') === 'true'));
    this.animationTimeout = null;
    
    // Set initial animation attribute on active tab/panel
    this.setAnimationAttribute(this.activeIndex);
    
    this.bindEvents();
  }

  bindEvents() {
    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', e => { 
        e.preventDefault(); 
        this.activate(i, true); 
      });
      tab.addEventListener('keydown', e => this.onKeyDown(e));
    });

    this.panels.forEach(panel => {
      panel?.addEventListener('keydown', e => {
        if (e.key === 'Escape') this.tabs[this.activeIndex]?.focus();
      });
    });
  }

  onKeyDown(e) {
    const actions = {
      ArrowLeft: () => this.focusOffset(-1),
      ArrowRight: () => this.focusOffset(1),
      Home: () => this.focusEnd(-1),
      End: () => this.focusEnd(1),
      Enter: () => this.activate(this.tabs.indexOf(document.activeElement), true),
      ' ': () => this.activate(this.tabs.indexOf(document.activeElement), true)
    };
    
    if (actions[e.key]) { 
      e.preventDefault(); 
      actions[e.key](); 
    }
  }

  isDisabled(i) {
    const tab = this.tabs[i];
    return tab?.disabled || tab?.getAttribute('aria-disabled') === 'true';
  }

  focusOffset(dir) {
    let i = this.tabs.indexOf(document.activeElement) + dir;
    const len = this.tabs.length;
    
    for (let n = 0; n < len; n++) {
      if (i < 0) i = this.options.loop ? len - 1 : 0;
      if (i >= len) i = this.options.loop ? 0 : len - 1;
      if (!this.isDisabled(i)) break;
      i += dir;
    }
    
    this.focusTab(i);
  }

  focusEnd(dir) {
    let i = dir < 0 ? 0 : this.tabs.length - 1;
    while (this.isDisabled(i) && i >= 0 && i < this.tabs.length) i -= dir;
    this.focusTab(i);
  }

  focusTab(i) {
    if (this.isDisabled(i)) return;
    this.tabs[i]?.focus();
    if (this.options.autoActivate) this.activate(i);
  }

  setAnimationAttribute(i) {
    // Clear any pending animation timeout
    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
      this.animationTimeout = null;
    }
    
    // Remove animation attribute from all tabs and panels
    this.tabs.forEach(tab => tab.removeAttribute('data-animation'));
    this.panels.forEach(panel => panel?.removeAttribute('data-animation'));
    
    // Add animation attribute after delay
    this.animationTimeout = setTimeout(() => {
      this.tabs[i]?.setAttribute('data-animation', '');
      this.panels[i]?.setAttribute('data-animation', '');
    }, this.options.animationDelay);
  }

  activate(i, focus = false) {
    if (this.isDisabled(i) || i === this.activeIndex) return;
    
    const prev = this.activeIndex;
    
    this.tabs.forEach((tab, idx) => {
      const isActive = idx === i;
      tab.setAttribute('aria-selected', isActive);
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel, idx) => {
      if (!panel) return;
      idx === i ? panel.removeAttribute('hidden') : panel.setAttribute('hidden', '');
    });

    this.activeIndex = i;
    if (focus) this.tabs[i]?.focus();
    
    // Trigger animation attribute with delay
    this.setAnimationAttribute(i);

    this.options.onChange?.({ prev, index: i, tab: this.tabs[i], panel: this.panels[i] });
  }

  goTo(i) { 
    this.activate(i, true); 
  }
  
  next() { 
    this.focusOffset(1); 
    this.activate(this.tabs.indexOf(document.activeElement), true); 
  }
  
  prev() { 
    this.focusOffset(-1); 
    this.activate(this.tabs.indexOf(document.activeElement), true); 
  }
}

const initTabs = () => {
  document.querySelectorAll('[data-tabs]').forEach(el => {
    if (!el._tabs) el._tabs = new Tabs(el);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTabs);
} else {
  initTabs();
}

window.Tabs = Tabs;
// NUTRITION LABEL
(function() {
  'use strict';

  const SELECTORS = {
    open: '[data-toggle-open]',
    close: '[data-toggle-close]',
    panel: '[data-toggle-panel]'
  };

  const FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(', ');

  const state = {
    activePanel: null,
    lastFocused: null
  };

  function getPanel(element) {
    const targetId = element.getAttribute('data-toggle-open');
    if (targetId) {
      return document.getElementById(targetId);
    }
    return element.closest(SELECTORS.panel);
  }

  function getOpenTriggers(panel) {
    return document.querySelectorAll(`[data-toggle-open="${panel.id}"]`);
  }

  function setAriaStates(panel, isOpen) {
    panel.setAttribute('aria-hidden', String(!isOpen));
    getOpenTriggers(panel).forEach(trigger => {
      trigger.setAttribute('aria-expanded', String(isOpen));
      trigger.setAttribute('aria-controls', panel.id);
    });
  }

  function moveFocus(panel) {
    const focusable = panel.querySelector(FOCUSABLE);
    if (focusable) {
      focusable.focus();
    } else {
      panel.setAttribute('tabindex', '-1');
      panel.focus();
    }
  }

  function trapFocus(event, panel) {
    const focusable = Array.from(panel.querySelectorAll(FOCUSABLE));
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function handleKeydown(event) {
    if (!state.activePanel) return;

    if (event.key === 'Escape') {
      close(state.activePanel);
    } else if (event.key === 'Tab') {
      trapFocus(event, state.activePanel);
    }
  }

  function open(panel, trigger) {
    if (!panel) return;

    state.lastFocused = trigger || document.activeElement;
    state.activePanel = panel;

    panel.classList.add('active');
    setAriaStates(panel, true);
    moveFocus(panel);

    document.addEventListener('keydown', handleKeydown);
  }

  function close(panel) {
    if (!panel) return;

    panel.classList.remove('active');
    setAriaStates(panel, false);

    document.removeEventListener('keydown', handleKeydown);

    if (state.lastFocused) {
      state.lastFocused.focus();
    }

    state.activePanel = null;
    state.lastFocused = null;
  }

  function handleClick(event) {
    const openTrigger = event.target.closest(SELECTORS.open);
    const closeTrigger = event.target.closest(SELECTORS.close);

    if (openTrigger) {
      const panel = getPanel(openTrigger);
      open(panel, openTrigger);
    } else if (closeTrigger) {
      const panel = getPanel(closeTrigger);
      close(panel);
    }
  }

  function init() {
    // Set initial ARIA states
    document.querySelectorAll(SELECTORS.panel).forEach(panel => {
      setAriaStates(panel, panel.classList.contains('active'));
      panel.setAttribute('role', 'dialog');
    });

    // Single delegated listener
    document.addEventListener('click', handleClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose API for programmatic control
  window.Toggle = { open, close };
})();

// ============================================= ============================================= ============================================= SECTION 6
(function() {
  'use strict';
  
  function setEqualHeights() {
    const titleElements = document.querySelectorAll('.co-nook-6-article-title');
    
    if (titleElements.length === 0) return;
    
    titleElements.forEach(el => el.style.height = 'auto');
    
    let maxHeight = 0;
    titleElements.forEach(el => {
      const height = el.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    
    titleElements.forEach(el => {
      el.style.height = maxHeight + 'px';
    });
  }

  const flkty = new Flickity('.co-nook-6-slider', {
    pageDots: false, 
    draggable: true,
    prevNextButtons: false,
    cellAlign: "left",
    contain: true,
    on: {
      ready: function() {
        setEqualHeights();
      },
      settle: function() {
        setEqualHeights();
      }
    }
  });
  
  window.addEventListener('resize', function() {
    flkty.resize();
    setEqualHeights();
  });
})();

// ============================================= ============================================= ============================================= SECTION 8

(function() {
    'use strict';
    var flkty = new Flickity('.co-nook-8 .main-carousel', {
        selectedAttraction: 0.01,
        // cellAlign: 'left',
        friction: 0.2,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        prevNextButtons: true,
        arrowShape: ''
    });
    const TRANSLATE_TARGET_CLASS = '.co-nook-8 .carousel-cell-transform-1';
    const TRANSLATE_Y_PREV = '50px';
    const TRANSLATE_Y_NEXT = '80px';
    function parseValue(value) {
    const match = value.match(/^(-?\d*\.?\d+)(.*)$/);
    return {
        number: parseFloat(match[1]),
        unit: match[2] || ''
    };
    }
    function calculateTranslateY(slide, viewport) {
    const slideRect = slide.getBoundingClientRect();
    const viewportRect = viewport.getBoundingClientRect();
    const slideCenterX = slideRect.left + slideRect.width / 2 - viewportRect.left;
    const viewportCenter = viewport.offsetWidth / 2;
    const slideWidth = slideRect.width;
    const distanceFromCenter = (slideCenterX - viewportCenter) / slideWidth;
    let value = 0;
    let unit = '';
    const prev = parseValue(TRANSLATE_Y_PREV);
    const next = parseValue(TRANSLATE_Y_NEXT);
    if (distanceFromCenter >= 1 && distanceFromCenter <= 2) {
        const progress = distanceFromCenter - 1;
        value = next.number * (1 - progress);
        unit = next.unit;
    } else if (distanceFromCenter >= 0 && distanceFromCenter < 1) {
        value = next.number * distanceFromCenter;
        unit = next.unit;
    } else if (distanceFromCenter >= -2 && distanceFromCenter <= -1) {
        const progress = Math.abs(distanceFromCenter) - 1;
        value = prev.number * (1 - progress);
        unit = prev.unit;
    } else if (distanceFromCenter >= -1 && distanceFromCenter < 0) {
        value = prev.number * Math.abs(distanceFromCenter);
        unit = prev.unit;
    }
    return `${value}${unit}`;
    }
    function updateSlideEffects() {
    const viewport = flkty.viewport;
    flkty.cells.forEach((cell) => {
        const slide = cell.element;
        const translateTarget = slide.querySelector(TRANSLATE_TARGET_CLASS);
        
        if (translateTarget) {
        const translateY = calculateTranslateY(slide, viewport);
        translateTarget.style.transform = `translateY(${translateY})`;
        }
    });
    }
    flkty.on('select', updateSlideEffects);
    flkty.on('dragMove', updateSlideEffects);
    flkty.on('scroll', updateSlideEffects);
    updateSlideEffects();
})();